import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import _typeof from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/typeof.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return '';
  } else if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (_typeof(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if (_typeof(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

// 替换邮箱字符
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    var str = email.split('@');
    var _s = '';
    if (str[0].length > 3) {
      for (var i = 0; i < str[0].length - 3; i++) {
        _s += '*';
      }
    }
    var new_email = str[0].substr(0, 3) + _s + '@' + str[1];
  }
  return new_email;
}

// 替换手机字符
export function regMobile(mobile) {
  if (mobile.length > 7) {
    var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7);
  }
  return new_mobile;
}

// 下载文件
export function downloadFile(obj, name, suffix) {
  var url = window.URL.createObjectURL(new Blob([obj]));
  var link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  var fileName = parseTime(new Date()) + '-' + name + '.' + suffix;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
/**
 * 将一维的扁平数组转换为多层级对象 仅适用于本项目的车队编码 ${7}${3}${4}${4}
 *
 * @param data
 * @param pTeamCode
 * @returns {[]}
 */
export function buildTeamTree(data) {
  var pTeamCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _fa = function fa(pTeamCode) {
    var temp = [];
    for (var i = 0; i < data.length; i++) {
      var n = data[i];
      if (getParentTeamCode(n['teamCode']) === pTeamCode) {
        n.children = _fa(n['teamCode']);
        temp.push(n);
      }
    }
    return temp;
  };
  return _fa(pTeamCode);
}
/**
 * 仅适用于本项目的车队编码 ${7}${3}${4}${4}
 */
export function getParentTeamCode(teamCode) {
  if (teamCode) {
    if (teamCode.length === 7) return null;
    if (teamCode.length === 10) return teamCode.substring(0, 7);
    if (teamCode.length === 14) return teamCode.substring(0, 10);
    if (teamCode.length === 18) return teamCode.substring(0, 14);
  }
}
import { Notification } from 'element-ui';
import moment from 'moment';
// 默认开始时间与结束时间不能超过30天
export function timeTest(endTime, beginTime) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  if (moment(endTime).diff(moment(beginTime)) > 3600 * 1000 * 24 * limit) {
    Notification({
      message: '开始时间和结束时间不能超过30天',
      type: 'warning'
    });
    return false;
  }
  return true;
}
import { getDictMap } from '@/api/system/dictDetail';
export function getDictList(_x) {
  return _getDictList.apply(this, arguments);
}
function _getDictList() {
  _getDictList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
    var info, list;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return getDictMap(key);
        case 1:
          info = _context2.v;
          list = [];
          list = info[key] || [];
          list = list.map(function (item) {
            return {
              label: item.label,
              value: item.value,
              type: 'info'
            };
          });
          return _context2.a(2, list);
      }
    }, _callee2);
  }));
  return _getDictList.apply(this, arguments);
}
export function $time(timestring) {
  return new function () {
    var t = this;
    t.nowtime = null;
    if (timestring !== undefined && timestring !== null) {
      if (timestring.toLocaleString().indexOf('T') >= 0) {
        t.nowtime = getTimeStamp(timestring);
      } else {
        if (typeof timestring === 'string') {
          t.nowtime = new Date(timestring.replace(' ', 'T')).getTime();
        } else {
          t.nowtime = new Date(timestring).getTime();
        }
      }
    }
    t.$now = function () {
      t.nowtime = new Date().getTime();
      return t;
    };
    t.addDays = function (adddays) {
      t.nowtime += adddays * (24 * 3600 * 1000);
      return t;
    };
    // 当前月第一天
    t.toStarDay = function () {
      var nowDate = new Date(t.nowtime);
      var data_s = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
      t.nowtime = data_s.getTime();
      return t;
    };
    // 当前月最后一天
    t.toEndDay = function () {
      var nowDate = new Date(t.nowtime);
      var data_e = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
      t.nowtime = data_e.getTime();
      return t;
    };
    t.addHour = function (adddays) {
      t.nowtime += adddays * (3600 * 1000);
      return t;
    };
    t.addMinute = function (adddays) {
      t.nowtime += adddays * 1000;
      return t;
    };
    t.addSecond = function (adddays) {
      t.nowtime += adddays;
      return t;
    };
    t.addMonths = function (admonths) {
      var nowDate = new Date(t.nowtime);
      var Monthnum = nowDate.getMonth() + 1;
      var Yearnum = nowDate.getFullYear();
      Monthnum += admonths;
      var years = parseInt(Monthnum / 12);
      var yearsMod = Monthnum % 12;
      if (Monthnum > 0) {
        if (yearsMod === 0 & years > 0) {
          years--;
        }
        Yearnum += years;
      } else {
        Yearnum--;
        Yearnum += years;
      }
      Monthnum = Monthnum % 12;
      Monthnum = Monthnum === 0 ? 12 : Monthnum;
      nowDate.setMonth(Monthnum - 1);
      nowDate.setFullYear(Yearnum);
      t.nowtime = nowDate.getTime();
      return t;
    };
    t.toISO = function () {
      return new Date(t.nowtime).getTime();
    };
    t.addyears = function (addyears) {
      var nowDate = new Date(t.nowtime);
      var Yearnum = nowDate.getFullYear();
      Yearnum += addyears;
      nowDate.setYear(Yearnum);
      t.nowtime = nowDate.getTime();
      return t;
    };
    t.toString = function (_datastring) {
      var Datastring = _datastring;
      var nowDate = new Date(t.nowtime);
      Datastring = treplace(Datastring, 'yyyy', nowDate.getFullYear());
      Datastring = treplace(Datastring, 'MM', nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1);
      Datastring = treplace(Datastring, 'dd', nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate());
      Datastring = treplace(Datastring, 'HH', nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours());
      Datastring = treplace(Datastring, 'mm', nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes());
      Datastring = treplace(Datastring, 'ss', nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds());
      return Datastring === '1970-01-01 08:00:00' ? '' : Datastring;
    };
  }();
}
function getTimeStamp(isostr) {
  var parts = isostr.match(/\d+/g);
  return new Date(parts[0] + '/' + parts[1] + '/' + parts[2] + ' ' + parts[3] + ':' + parts[4] + ':' + parts[5]).getTime() + 3600 * 1000 * 8;
}
function treplace(text, s1, s2) {
  return text.replace(new RegExp(s1, 'gm'), s2);
}
export function includess(arr1, arr2) {
  console.log(arr2.every(function (val) {
    return arr1.includes(val);
  }), 'console.log(arr1.includes(val), \'arr1.includes(val)\');\n');
  return arr2.every(function (val) {
    console.log(arr1.includes(val), 'arr1.includes(val)');
    return arr1.includes(val);
  });
}
export function torepeat(alldata, objs) {
  var obj = {};
  var arr = [];
  arr = alldata.reduce(function (prev, curr) {
    if (objs) {
      var strArr = [];
      objs.forEach(function (value) {
        strArr.push(curr[value]);
      });
      if (!obj[strArr.join('____')]) {
        obj[strArr.join('____')] = true;
        prev.push(curr);
      }
    } else {
      if (!obj[curr]) {
        obj[curr] = true;
        prev.push(curr);
      }
    }
    return prev;
  }, []);
  return arr;
}
export function cmConvertPinyin(l1) {
  if (l1 === undefined) {
    return;
  }
  if (l1 == null) {
    return;
  }
  var l2 = l1.length;
  var I1 = '';
  var I2 = '';
  var reg = new RegExp('[a-zA-Z0-9\- ]');
  for (var i = 0; i < l2; i++) {
    var val = l1.substr(i, 1);
    var name = arraySearch(val);
    if (reg.test(val)) {
      I1 += val;
    } else if (name !== false) {
      I1 += name;
      I2 += name.substr(0, 1);
    }
  }
  return {
    qp: I1,
    jp: I2
  };
}
export function parseSecondTime(timer) {
  var time = '';
  var thisTime = '';
  if (timer != null && timer != "") {
    thisTime = timer.replace(/-/g, '/');
    time = new Date(thisTime);
    time = time.getTime() / 1000;
  }
  return time;
}
export function null2str(data) {
  for (var key in data) {
    if (data.hasOwnProperty.call(data, key)) {
      if (data[key] == null || data[key] === "" || data[key] === "{}") {
        // 如果是null和underfined和空字符串 把直接内容转为 '-'
        data[key] = "-";
      } else {
        if (Array.isArray(data[key])) {
          // 是数组遍历数组 递归继续处理
          data[key] = data[key].map(function (item) {
            return null2str(item);
          });
        }
        if (_typeof(data[key]) === "object") {
          // 是json 递归继续处理
          data[key] = null2str(data[key]);
        }
      }
    }
  }
  return data;
}
export function getParamsFromUrl(url, name) {
  try {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = url.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  } catch (e) {
    return null;
  }
}
import * as dd from 'dingtalk-jsapi';
export function requestAuthCode(corpId) {
  return new Promise(function (resolve, reject) {
    dd.ready(function () {
      // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
      dd.runtime.permission.requestAuthCode({
        corpId: corpId,
        onSuccess: function () {
          var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(result) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  resolve(result.code);
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          function onSuccess(_x2) {
            return _onSuccess.apply(this, arguments);
          }
          return onSuccess;
        }(),
        onFail: function onFail(err) {
          reject();
        }
      });
    });
  });
}

/**
 * 动态加载百度地图api函数
 * @param {String} ak  百度地图AK，必传
 */
export function loadBMap() {
  return new Promise(function (resolve, reject) {
    if (typeof window.BMap !== "undefined") {
      resolve(window.BMap);
      return true;
    }
    window.onBMapCallback = function () {
      resolve(window.BMap);
      return true;
    };
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://api.map.baidu.com/api?v=3.0&ak=r72PuNbZ4sEDk6SZjiK86A2ROQoYfWEi&callback=onBMapCallback&s=1";
    script.onerror = reject;
    document.head.appendChild(script);
    return true;
  });
}

// 生成随机数
export function randomStr(range) {
  var str = '';
  var pos = '';
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
  arr.concat(['i', 'j', 'k', 'l', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']);
  for (var i = 0; i < range; i++) {
    pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}